//extracted by mini-css-extract-plugin
export default {"horizontalChips":"RCACellComponent_horizontalChips__EkWKo","purpleChip":"RCACellComponent_purpleChip__cnRWU","greyChip":"RCACellComponent_greyChip__8VuDA"};;